<template>
   <div class="adminPage DataUpdate">
      <modal
         name="GradeModal"
         width="80%"
         height="auto"
         :scrollable="true"
         :adaptive="true"
         :clickToClose="false"
         >
         <div class="modalContainer">
            <div class="tabcontent">
               <ValidationObserver ref="obsFieldsUpdate">
                  <FormUpdateBosses
                     :FieldsForm="formUpdate"
                     :ModelForm="formUpdModel"
                     :method="executeProcess"
                     v-if="renderComponent2"
                     />
               </ValidationObserver>
               <div class="modalActions">
                  <div style="flex:1">
                     <va-notification
                        color="danger"
                        v-if="refValidator"
                        class="refNoData"
                        >
                        {{ AlertValidator }}
                     </va-notification>
                  </div>
                  <button
                     v-if="isNew === false"
                     id="updateImmediate"
                     class="loginbtn primaryBtn"
                     @click="UpdateImmediate"
                     >
                  Actualizar
                  </button>
                  <button
                     v-if="isNew === true"
                     id="AddModal"
                     class="loginbtn primaryBtn"
                     @click="AddModal"
                     >
                  Guardar
                  </button>
                  <button
                     id="CancelImmediate"
                     class="loginbtn secondaryBtn"
                     @click="CancelImmediate"
                     >
                  Cancelar
                  </button>
               </div>
            </div>
         </div>
      </modal>
      <modal
         name="UploadExcelModal"
         width="40%"
         height="auto"
         :scrollable="true"
         :adaptive="true"
         :clickToClose="false"
         >
         <div class="modalContainer">
            <div class="titlePage">
               Carga Masiva Excel
            </div>
            <p>
               Por favor cargue el archivo <strong>Excel</strong> con la plantilla correspondiente.
            </p>
            <ValidationObserver ref="obsFieldsUpdate">
               <FormUploadExcel
                  :FieldsForm="formUpload"
                  :ModelForm="formInsModel"
                  :method="executeProcess"
                  v-if="renderComponent3"
                  />
               <div id="div_Respuesta"></div>
               <div class="helpLink">
                  <a
                     href="https://services.ibero.edu.co/Files/ManualCargueMasivo.pdf"
                     target="_blank"
                     >
                  ¿Necesitas ayuda? Haz click aquí
                  </a>
               </div>
            </ValidationObserver>
            <div class="modalActions">
               <button
                  class="loginbtn secondaryBtn"
                  @click="CancelExcel"
                  >
               Cancelar
               </button>
            </div>
         </div>
      </modal>
      <!-- MODAL ELIMINAR REGISTRO -->
      <modal
         name="DeleteConfirmModal"
         width="40%"
         height="auto"
         :scrollable="true"
         :adaptive="true"
         :clickToClose="false"
         >
         <div class="modalContainer">
            <div class="titlePage">
               Confirmar Eliminación
            </div>
            <p>
               ¿Estás seguro de eliminar el dato seleccionado?
            </p>
            <div v-if="selectedItem">
               <p><strong>Docente:</strong> {{ selectedItem.idBannerDocente }}</p>
               <p><strong>Nombre:</strong> {{ selectedItem.nombreDocente }}</p>
               <p><strong>Jefe:</strong> {{ selectedItem.idJefeInmediato }}</p>
               <p><strong>Nombre:</strong> {{ selectedItem.nombreJefe }}</p>
            </div>
            <div class="modalActions">
               <va-notification
                  color="danger"
                  v-if="refValidator"
                  class="refNoData"
                  >
                  {{ AlertValidator }}
               </va-notification>
               <button
                  id="confirmDelete"
                  class="loginbtn btnDanger"
                  @click="handleDelete"
                  >
               Eliminar
               </button>
               <button
                  class="loginbtn secondaryBtn"
                  @click="CancelImmediateDelete"
                  >
               Cancelar
               </button>
            </div>
         </div>
      </modal>
      <!-- MODAL ELIMINAR TODO -->
      <modal
         name="DeleteConfirmModalM"
         width="40%"
         height="auto"
         :scrollable="true"
         :adaptive="true"
         :clickToClose="false"
         >
         <div class="modalContainer">
            <div class="titlePage">
               Eliminar todos los registros
            </div>
            <p>
               ¿Estás seguro de eliminar todos los datos existentes?
            </p>
            <div class="modalActions">
               <va-notification
                  color="danger"
                  v-if="refValidator"
                  class="refNoData"
                  >
                  {{ AlertValidator }}
               </va-notification>
               <button
                  id="confirmDeleteM"
                  class="loginbtn btnDanger"
                  @click="handleDeleteAll"
                  >
               Eliminar
               </button>
               <button
                  class="loginbtn secondaryBtn"
                  @click="CancelDelete"
                  >
               Cancelar
               </button>
            </div>
         </div>
      </modal>
      <!-- TITULO -->
      <div class="titlePage">
         Evaluación Docente - Administrador Jefe(s) Inmediato(s)
      </div>
      <!-- NOTIFICACIONES -->
      <va-notification color="success" v-if="addRExito" class="refNoData">
         Se creó correctamente el dato solicitado.
      </va-notification>
      <va-notification color="success" v-if="addRExitoExc" class="refNoData">
         Se realizó correctamente el cargue de datos.
      </va-notification>
      <va-notification color="success" v-if="UpdRExito" class="refNoData">
         Se actualizó correctamente el dato solicitado.
      </va-notification>
      <va-notification color="success" v-if="delRExito" class="refNoData">
         Se eliminó correctamente el dato solicitado.
      </va-notification>
      <va-notification color="danger" v-if="refWSCreate" class="refNoData">
         El servicio de creación no se encuentra activo.
      </va-notification>
      <va-notification color="danger" v-if="refNoUpdate" class="refNoData">
         La actualización presentó un fallo.
      </va-notification>
      <va-notification color="danger" v-if="refWSUpdate" class="refNoData">
         El servicio de actualización no se encuentra activo.
      </va-notification>
      <va-notification color="danger" v-if="refWSDelete" class="refNoData">
         El servicio de eliminación no se encuentra activo.
      </va-notification>
      <!-- BUSCADOR -->
      <ValidationObserver ref="obsFieldsSearch">
         <FormSearchBosses
            :FieldsForm="formSearch"
            :ModelForm="formSchModel"
            :method="executeProcess"
            />
      </ValidationObserver>
      <va-notification
         color="danger"
         id="refNoData"
         class="refNoData noShow"
         >
         No se encontró información registrada.
      </va-notification>
      <!-- TABLA -->
      <div class="tableCard">
         <DataTableBosses
            :InfoView="DLImmediateBosses"
            :HeadTable="HDImmediateBosses"
            :method="handleAction"
            v-if="renderComponent1"
            />
      </div>
   </div>
</template>
<script>
import FormSearchBosses from '@/components/forms/Forms.vue'
import FormUpdateBosses from '@/components/forms/Forms.vue'
import FormUploadExcel from '@/components/forms/Forms.vue'
import IberoHelpers from '@/store/helpers.js'
import DataTableBosses from '@/components/data-tables/DataImmediateBosses.vue'

export default {
  name: 'DataUpdate',
  components: {
    DataTableBosses,
    FormSearchBosses,
    FormUpdateBosses,
    FormUploadExcel,
  },
  data () {
    return {
      AlertValidator: '',
      formSchModel: {},
      formSearch: [
        { id: 'Sch_Button', type: 'button', placeholder: 'Importar Excel', class: 'col-md-4' },
        { id: 'Sch_ButtonNew', type: 'button', placeholder: 'Crear Jefe Inmediato', class: 'col-md-4' },
        { id: 'Sch_ButtonDelete', type: 'button', placeholder: 'Eliminar Data', class: 'col-md-4' },
      ],
      formUpdModel: {
        Id: 0,
        IdJefe: 0,
        IdDocente: 0,
        IdFacultad: 0,
        Programa: '',
        Area: '',
      },
      formUpload: [
        {
          id: 'IdFile',
          placeholder: 'Examinar',
          type: 'file',
          values: '',
          validate: { required: false },
          class: 'col-md-9',
        },
        { id: 'IdProcessFile', type: 'button', placeholder: 'Procesar', class: 'col-md-3' },
        { id: 'IdTextFind', model: 'IdTextFind', type: 'html', values: '', class: 'col-md-12' },
      ],
      formInsModel: { IdFile: '' },
      formUpdate: [
        {
          id: 'IdJefe',
          model: 'IdJefe',
          name: 'Jefe Inmediado',
          type: 'Select',
          placeholder: 'Jefe Inmediado',
          class: 'col-md-4',
          values: this.$store.state.ImmediateBossesList,
          validate: { required: true },
        },
        {
          id: 'IdDocente',
          model: 'IdDocente',
          name: 'Docente',
          type: 'Select',
          placeholder: 'Docente',
          class: 'col-md-4',
          values: this.$store.state.TeachersList,
          validate: { required: true },
        },
        {
          id: 'IdFacultad',
          model: 'IdFacultad',
          name: 'Facultad',
          type: 'Select',
          placeholder: 'Facultad',
          class: 'col-md-4',
          values: this.$store.state.FacultyList,
          validate: { required: true },
        },
        {
          id: 'Programa',
          model: 'Programa',
          name: 'Programa',
          type: 'Select',
          placeholder: 'Programa',
          class: 'col-md-4',
          values: this.$store.state.ProgramCodeList,
          validate: { required: true },
        },
        {
          id: 'Area',
          model: 'Area',
          name: 'Area',
          type: 'Select',
          placeholder: 'Area',
          class: 'col-md-8',
          values: [
            { id: 'N/A', value: 'No Aplica' },
            { id: 'Ciencias Básicas', value: 'Ciencias Básicas' },
            { id: 'Bilingüismo', value: 'Bilingüismo' },
          ],
          validate: { required: true, regex: '^([a-zA-z]?)' },
        },
      ],
      HDImmediateBosses: [
        { name: 'id', title: 'Identificador', sortField: 'id', width: '5%' },
        { name: 'idBannerDocente', title: 'ID Banner Docente', sortField: 'idBannerDocente', width: '5%' },
        { name: 'nombreDocente', title: 'Nombre Docente', sortField: 'nombreDocente', width: '20%' },
        { name: 'idJefeInmediato', title: 'ID Banner Jefe Inmediato', sortField: 'idJefeInmediato', width: '10%' },
        { name: 'nombreJefe', title: 'Nombre Jefe Inmediato', sortField: 'nombreJefe', width: '20%' },
        { name: 'facultad', title: 'Facultad', sortField: 'facultad', width: '20%' },
        { name: 'programa', title: 'Código Programa', sortField: 'programa', width: '10%' },
        { name: 'area', title: 'Área', sortField: 'area', width: '20%' },
        {
          name: '__slot:actions',
          title: '',
          dataClass: 'text-center',
          width: '2%',
          actionRef: [
            { label: 'Editar', icon: 'fa-pencil', action: 'edit' },
            { label: 'Eliminar', icon: 'fa-trash', action: 'delete' },
          ],
        },
      ],
      DLImmediateBosses: [],
      formUserFileModel: [],
      renderComponent1: false,
      renderComponent2: false,
      renderComponent3: false,
      addRExito: false,
      addRExitoExc: false,
      UpdRExito: false,
      delRExito: false,
      refNoUpdate: false,
      refWSCreate: false,
      refWSUpdate: false,
      refWSDelete: false,
      refValidator: false,
      isNew: false,
      showDeleteModal: false,
      selectedItem: {},
    }
  },
  methods: {
    executeProcess: function (event, refer) {
      this.limpiaref()
      switch (event.target.id) {
        case 'btn_Sch_Button':
          this.limpiaref()
          this.isNew = true
          IberoHelpers.forceRerender3(this)
          this.$modal.show('UploadExcelModal')
          break
        case 'btn_Sch_ButtonNew':
          this.limpiaref()
          this.isNew = true
          IberoHelpers.forceRerender2(this)
          this.$modal.show('GradeModal')
          break
        case 'btn_Sch_ButtonDelete':
          this.$modal.show('DeleteConfirmModalM')
          break
        case 'IdFile':
          document.getElementById('div_Respuesta').innerHTML = ''
          this.formUserFileModel = []
          if (
            event.target.files[0].name
              .split('.')
              .pop()
              .indexOf('xls') === 0
          ) {
            event.target.nextElementSibling.innerText =
                            event.target.files[0].name
            this.formUserFileModel.push({ filedata: event.target.files[0] })
          } else {
            alert('El archivo cargado no es valido.')
          }
          break
        case 'btn_IdProcessFile':
          if (this.formUserFileModel.length > 0) {
            var dataFile = IberoHelpers.sendUpdloadFile(
              this.$store,
              this.formUserFileModel,
              'JEFEINMEDIATO',
              0
            )
            document.getElementById('IdFile').nextElementSibling.innerText =
                            'Procesando.....'
            document.getElementById('btn_IdProcessFile').style.display = 'none'
            dataFile.then(Response => {
              if (
                Response !== false &&
                                Response[0].wsDocument.data.id_File !== undefined
              ) {
                dataFile = IberoHelpers.processMassiveBosses(
                  this.$store,
                  JSON.parse(Response[0].wsDocument.data.id_File)[0]
                )
                dataFile.then(Response => {
                  if (Response !== false) {
                    this.formUserFileModel = []
                    var sTable =
                                    "<div class='alert alert-success' role='alert'>" +
                                    'Resultado.' +
                                    '</div> '
                    if (Response.data.message !== '') {
                      sTable =
                                        "<table class='table table-hover' id='myTable2' ref='table'>" +
                                        '       <thead>' +
                                        '         <tr>' +
                                        "           <th scope='col'>Respuesta</th>" +
                                        '         </tr>' +
                                        '       </thead>' +
                                        '       <tbody> '

                      try {
                        for (var i = 0; i < JSON.parse(Response.data.message).length; i++) {
                          sTable +=
                                            '<tr> <td>' +
                                                JSON.parse(Response.data.message)[i] +
                                            '</td></tr>'
                        }
                      } catch (error) {
                        sTable +=
                                        '<tr> <td>' + Response.data.message + '</td></tr>'
                      }
                      sTable += '</tbody> </table>'
                    }
                  } else {
                    alert('No es posible procesar el archivo error de conexión !!!')
                  }
                  document.getElementById('div_Respuesta').innerHTML = sTable
                  document.getElementById('btn_IdProcessFile').style.display = ''
                  document.getElementById('IdFile').nextElementSibling.innerText = ''
                })
              } else {
                alert('No es posible cargar el archivo al sistema error de conexión !!!')
                document.getElementById('btn_IdProcessFile').style.display = ''
                document.getElementById('IdFile').nextElementSibling.innerText = ''
              }
            })
          } else {
            alert('No ha cargado ningun archivo para procesar.')
          }
          break
      }
      this.$refs.obsFieldsSearch.validate()
    },

    UpdateImmediate () {
      return new Promise((resolve, reject) => {
        this.$refs.obsFieldsUpdate.validate().then(results => {
          if (!results) {
            resolve(false)
          } else {
            let loader = this.$loading.show()
            debugger
            let dataToSend = {
              id: this.formUpdModel.Id,
              idJefe: this.formUpdModel.IdJefe,
              idDocente: this.formUpdModel.IdDocente,
              idFacultad: this.formUpdModel.IdFacultad,
              programa: this.formUpdModel.Programa,
              area: this.formUpdModel.Area,
            }
            var totalinf = IberoHelpers.UpdateImmediateBoss(this.$store, dataToSend)
            totalinf.then(Response => {
              if (Response.status === 200) {
                this.UpdRExito = true
              }
              this.$modal.hide('GradeModal')
              this.refreshData()
              loader.hide()
              resolve(true)
            }).catch(error => {
              this.refNoUpdate = true
              this.refreshData()
              loader.hide()
              resolve(false)
            })
          }
        })
      })
    },

    AddModal () {
      return new Promise((resolve, reject) => {
        this.$refs.obsFieldsUpdate.validate().then(results => {
          if (!results) {
            resolve(false)
          } else {
            let loader = this.$loading.show()
            debugger
            let dataToSend = {
              idJefe: this.formUpdModel.IdJefe,
              idDocente: this.formUpdModel.IdDocente,
              idFacultad: this.formUpdModel.IdFacultad,
              programa: this.formUpdModel.Programa,
              area: this.formUpdModel.Area,
            }
            var totalinf = IberoHelpers.CreateImmediateBoss(this.$store, dataToSend)
            totalinf.then(Response => {
              if (Response.status === 200) {
                this.addRExito = true
              }
              this.$modal.hide('GradeModal')
              this.refreshData()
              loader.hide()
              resolve(true)
            }).catch(error => {
              this.refWSCreate = true
              this.refreshData()
              loader.hide()
              resolve(false)
            })
          }
        })
      })
    },

    limpiaref () {
      this.addRExito = false
      this.UpdRExito = false
      this.refNoUpdate = false
      this.refWSUpdate = false
      this.refValidator = false
      document.getElementById('refNoData').classList.add('noShow')
    },

    CancelImmediate () {
      this.limpiaref()
      this.clearFields()
      this.$modal.hide('GradeModal')
    },

    CancelExcel () {
      this.limpiaref()
      this.clearFields()
      this.$modal.hide('UploadExcelModal')
    },

    handleAction (dataInf, action) {
      if (action === 'edit') {
        this.isEdit = true
        this.processData(dataInf)
      } else if (action === 'delete') {
        this.selectedItem = dataInf
        this.$modal.show('DeleteConfirmModal')
      }
    },

    processData (dataInf) {
      this.limpiaref()
      this.clearFields()
      console.log(dataInf)

      this.isNew = false
      this.formUpdModel.Id = dataInf.id
      this.formUpdModel.IdJefe = dataInf.idJefeInmediato
      this.formUpdModel.IdDocente = dataInf.idBannerDocente
      this.formUpdModel.IdFacultad = dataInf.idFacultad
      this.formUpdModel.Programa = dataInf.programa
      this.formUpdModel.Area = dataInf.area

      IberoHelpers.forceRerender2(this)
      this.$modal.show('GradeModal')
    },

    clearFields () {
      this.formUpdModel.IdJefe = 0
      this.formUpdModel.IdDocente = 0
      this.formUpdModel.IdFacultad = 0
      this.formUpdModel.Programa = ''
      this.formUpdModel.Area = ''
    },

    handleDelete () {
      debugger
      if (this.selectedItem && this.selectedItem.id) {
        this.confirmDelete(this.selectedItem.id)
      }
    },

    confirmDelete (id) {
      return new Promise((resolve, reject) => {
        let loader = this.$loading.show()

        var totalinf = IberoHelpers.DeleteImmediateBoss(this.$store, id)
        totalinf.then(Response => {
          if (Response.status === 200) {
            this.delRExito = true
          }
          this.refreshData()
          loader.hide()
          this.$modal.hide('DeleteConfirmModal')
          resolve(true)
        }).catch(error => {
          this.refWSDelete = true
          this.refreshData()
          loader.hide()
          this.$modal.hide('DeleteConfirmModal')
          resolve(false)
        })
      })
    },

    CancelImmediateDelete () {
      this.limpiaref()
      this.clearFields()
      this.$modal.hide('DeleteConfirmModal')
    },

    handleDeleteAll () {
      return new Promise((resolve, reject) => {
        let loader = this.$loading.show()

        var totalinf = IberoHelpers.DeleteAllInmediateBosses(this.$store)
        totalinf.then(Response => {
          if (Response && Response.status === 200) {
            this.delRExito = true
          }
          this.refreshData()
          loader.hide()
          this.$modal.hide('DeleteConfirmModalM')
          resolve(true)
        }).catch(error => {
          this.refWSDelete = true
          this.refreshData()
          loader.hide()
          this.$modal.hide('DeleteConfirmModalM')
          resolve(false)
        })
      })
    },

    CancelDelete () {
      this.$modal.hide('DeleteConfirmModalM')
    },

    refreshData () {
      this.loadImmediateBosses()
    },

    async loadImmediateBosses () {
      let loader = this.$loading.show()
      try {
        this.DLImmediateBosses = []
        await this.$nextTick()

        var immediateBosses = await IberoHelpers.getImmediateBosses(this.$store)

        this.DLImmediateBosses = Array.isArray(immediateBosses.data)
          ? immediateBosses.data
          : [immediateBosses.data]
        IberoHelpers.forceRerender1(this)
        this.renderComponent1 = false
        await this.$nextTick()
        this.renderComponent1 = true
      } catch (error) {
        console.error('Error obteniendo datos:', error)
      } finally {
        loader.hide()
      }
    },
  },
  mounted: async function () {
    this.loadImmediateBosses()
  },
}
</script>